import { createSlice } from '@reduxjs/toolkit';
import groupApi from 'api/groupApi';
import userGroupApi from 'api/userGroupApi';

const initialState = {
  groupDetail: [],
  recentDataList: {
    _id: '',
    type: '',
  },
  intakeGroup: [],
  trigger: '',
  cardIds: [],
  childIds: {},
};

const courseSlice = createSlice({
  name: 'detailPage',
  initialState,
  reducers: {
    setGroupDetail: (state, action) => {
      state.groupDetail = action.payload;
    },
    setRecentList: (state, action) => {
      state.recentDataList = action.payload;
    },
    setintakeGroup: (state, action) => {
      state.intakeGroup = action.payload;
    },
    setFirstTrigger: (state, action) => {
      state.trigger = action.payload;
    },
    addActiveCardId: (state, action) => {
      const newArray = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      state.cardIds.push(...newArray);
    },
    updateChildId: (state, action) => {
      state.childIds[action.payload.key] = action.payload.value;
    },

    removeChildId: (state, action) => {
      const { [action.payload]: removedKey, ...restObj } = state.childIds;
      state.childIds = {
        ...restObj,
      };
    },

    removeActiveCardId: (state, action) => {
      const updatedCardIds = state.cardIds.filter(
        (id) => id !== action.payload,
      );
      state.cardIds = updatedCardIds;
    },
    clearActiveIds: (state) => {
      state.cardIds = [];
    },
  },
});

export const getGroupDetail = (state) => state.detailPage.groupDetail;

export const getRecentDataList = (state) => state.detailPage.recentDataList;

export const getIntakeGroup = (state) => state.detailPage.intakeGroup;

export const getTrigger = (state) => state.detailPage.trigger;

export const getActiveCardIds = (state) => state.detailPage.cardIds;

export const getChildCardIds = (state) => state.detailPage.childIds;

export const {
  setGroupDetail,
  setRecentList,
  setintakeGroup,
  setFirstTrigger,
  addActiveCardId,
  removeActiveCardId,
  clearActiveIds,
  updateChildId,
  removeChildId,
} = courseSlice.actions;

const typeOfApi = {
  isIntake: groupApi.getGroupList,
  GROUP: groupApi.getGroupContent,
  SECTION: groupApi.getSectionList,
  SUB_SECTION: groupApi.getSubSectionList,
  // lessons
  isAllLesson: userGroupApi.getAllLessonByIntake,
  UNIT: groupApi.getUnitList,
  UnitSection: groupApi.getUnitSection,
  SectionSub: groupApi.getSectionBySub,
};

export const getGroupDetailAsync = async (type, value, index, nextApiType) => {
  let response = await typeOfApi[type](value?._id, value?.params);
  let emptyLesson = false;
  // if lesson is empty then call next api
  if (response?.lessons && !response?.lessons?.length && nextApiType[type]) {
    emptyLesson = true;
    response = await typeOfApi[nextApiType[type]](value?._id, {
      ...value?.params,
      page: 1,
    });
  }
  return emptyLesson ? { ...response, emptyLesson } : response;
};

export default courseSlice.reducer;
